/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nudge_Rehearse_This_Meeting_ActionInputs */



/**
* | output |
* | --- |
* | "Practise this conversation" |
*
* @param {Nudge_Rehearse_This_Meeting_ActionInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const nudge_rehearse_this_meeting_action = /** @type {((inputs?: Nudge_Rehearse_This_Meeting_ActionInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nudge_Rehearse_This_Meeting_ActionInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Oefen dit gesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Répéter cette conversation")
	return /** @type {LocalizedString} */ ("Practise this conversation")
});